const COLOURS = {
  primary: {
    black: "#000000",
    white: "#FFFFFF",
    blue: "#003FFF",
  },
};

const BORDERS = {
  primary: "rgba(255, 255, 255, 1)",
  secondary: "rgba(0, 0, 0, 1)",
};

export { COLOURS, BORDERS };
